// extracted by mini-css-extract-plugin
export default {"tasks":"yM-z","task":"zM-z","svg":"AM-z","text":"BM-z"};